<template>
  <div>
    <v-layout row justify-center>
      <v-flex xs12>
        <l-cache :get-data="getFormData" :id="this.$route.query.id" ref="cache">
          <template slot-scope="{data}">
            <reservation-detail-content :form-data="data" :config="config" :reservation-type="reservationType"></reservation-detail-content>
          </template>
        </l-cache>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import reservationDetailContent from './reservationDetailContent'
import {LetterReservation} from '../../../object'

var formData = {
  appl: {
    applId: ''
  },
  bulkImpVeList: [],
  host: {
    hostGroupId: '',
    hostId: '',
    hostOrgId: ''
  },
  letterApptDesc: '',
  letterApptName: '',
  letterApptType: '',
  maxSelfReg: '',
  needReview: false,
  passRuleConf: '',
  passRulePara: '',
  qrcodeEndDtm: '',
  qrcodeStaDtm: '',
  veSelfRegRule: {
    id: false,
    idType: false,
    name: false,
    org: false,
    phone: true,
    veNum: true
  }
}
export default{
  name: 'letterReservation',
  components: {
    reservationDetailContent
  },
  data: () => ({
    /* 函件预约相关参数配置 */
    config: {
      /* 组件状态 */
      status: '',
      /* 流程实例ID */
      procInstId: '',
      /* 任务ID */
      taskId: '',
      /* 任务相关配置 */
      taskConfig: '',
    },
    /* 函件预约类型：普通| 追加 */
    reservationType: 'common'
  }),
  created () {
    this.init()
  },
  activated () {
    this.init()
  },
  methods: {
    /* 获取函件预约已提交表单信息 */
    async getFormData () {
      if (this.config.status === 'read') {
        return this.dealReadReservation()
      }
      else if (this.reservationType === 'add') {
        return this.dealAddReservation()
      }
      else if (this.config.status === 'edit') {
        return this.dealEditReservation()
      }
      else if (this.config.status === 'review') {
        return this.dealReviewReservation()
      }
      else {
        return this.dealReadReservation()
      }
      /*      let res = await this.$store.dispatch('letterReservation/getFormData', this.config)
      if (res.data.code + '' === '200') {
        // console.log(res)
        if (res.data.data === null) {
          return new LetterReservation()
        }
        else {
          let formValue = eval('(' + res.data.data.formValueJson + ')')
          // console.log(formValue)
          return formValue
        }
      } */
    },
    async dealAddReservation () {
      let config = {
        'assignee': this.getUserInfo().id,
        'procInstId': this.$route.query.id,
        'groups': [
          'user'
        ]
      }
      let res1 = await this.$store.dispatch('letterReservation/editReservation', config)
      if (res1.data.code + '' === '200') {
        let taskConfig = res1.data.data[0]
        this.config.procInstId = taskConfig.processInstanceId
        this.config.taskId = taskConfig.taskId
        this.config.taskConfig = eval('(' + taskConfig.taskConfig + ')')
        let tmpConfig = {
          procInstId: res1.data.data[0].parentProcInstId,
          taskConfig: this.config.taskConfig
        }
        let res2 = await this.$store.dispatch('letterReservation/getFormData', tmpConfig)
        if (res2.data.code + '' === '200') {
          let parentFormValue = eval('(' + res2.data.data.formValueJson + ')')
          let res = await this.$store.dispatch('letterReservation/getFormData', this.config)
          if (res.data.code + '' === '200') {
            if (res.data.data === null) {
              let newForm = new LetterReservation()
              newForm.letterApptName = parentFormValue.letterApptName
              newForm.letterApptType = parentFormValue.letterApptType
              newForm.letterApptDesc = parentFormValue.letterApptDesc
              newForm.appl = parentFormValue.appl
              newForm.host = parentFormValue.host
              return newForm
            }
            else {
              let formValue = eval('(' + res.data.data.formValueJson + ')')
              // console.log(formValue)
              return formValue
            }
          }
        }
      }
    },
    async dealReadReservation () {
      let res1 = await this.$store.dispatch('letterReservation/readReservation', this.$route.query.id)
      if (res1.data.code + '' === '200') {
        console.log(res1)
        let taskConfig = res1.data.data.taskConfig
        this.config.procInstId = res1.data.data.processInstanceId
        this.config.taskId = res1.data.data.taskId
        this.config.taskConfig = eval('(' + taskConfig + ')')
        let res = await this.$store.dispatch('letterReservation/getFormData', this.config)
        if (res.data.code + '' === '200') {
          if (res.data.data === null) {
            return new LetterReservation()
          }
          else {
            let formValue = eval('(' + res.data.data.formValueJson + ')')
            console.log(formValue)
            return formValue
          }
        }
      }
    },
    async dealEditReservation () {
      let config = {
        'assignee': this.getUserInfo().id,
        'procInstId': this.$route.query.id,
        'groups': [
          'user'
        ]
      }
      let res1 = await this.$store.dispatch('letterReservation/editReservation', config)
      if (res1.data.code + '' === '200') {
        // console.log(res1)
        let taskConfig = res1.data.data[0]
        this.config.procInstId = taskConfig.processInstanceId
        this.config.taskId = taskConfig.taskId
        this.config.taskConfig = eval('(' + taskConfig.taskConfig + ')')
        let res = await this.$store.dispatch('letterReservation/getFormData', this.config)
        if (res.data.code + '' === '200') {
          if (res.data.data === null) {
            return new LetterReservation()
          }
          else {
            let formValue = eval('(' + res.data.data.formValueJson + ')')
            console.log(formValue)
            return formValue
          }
        }
      }
      else {
        this.$L.alert('error', {message: '查询任务失败'})
      }
    },
    async dealReviewReservation () {
      let config = {
        'procDefId': sessionStorage.getItem('processId'),
        'procInstId': this.$route.query.id,
        'groups': [
          'admin'
        ]
      }
      let res1 = await this.$store.dispatch('letterReservation/getReviewTask', config)
      if (res1.data.code + '' === '200') {
        if (res1.data.data[0] !== undefined || res1.data.data[0] != null) {
          let config = {
            'taskIdList': [res1.data.data[0].taskId],
            'assignee': this.getUserInfo().id
          }
          let res2 = await this.$store.dispatch('letterReservation/signTask', config)
          if (res2.data.code + '' === '200') {
            let taskConfig = res1.data.data[0]
            this.config.taskId = taskConfig.taskId
            this.config.procInstId = taskConfig.processInstanceId
            this.config.taskConfig = eval('(' + taskConfig.taskConfig + ')')
            let res = await this.$store.dispatch('letterReservation/getFormData', this.config)
            if (res.data.code + '' === '200') {
              if (res.data.data === null) {
                return new LetterReservation()
              }
              else {
                let formValue = eval('(' + res.data.data.formValueJson + ')')
                console.log(formValue)
                return formValue
              }
            }
          }
          else {
            this.$L.alert('error', {message: res2.data.msg})
          }
        }
        else {
          this.$L.alert('error', {message: '未查询到任务'})
        }
      }
      else {
        this.$L.alert('error', {message: '查询任务失败'})
      }
    },
    /* 初始化组件相关数据 */
    init () {
      let params = this.$route.query
      this.config.status = params.status
      if (params.reservationType !== undefined) {
        this.reservationType = params.reservationType
      }
    },
    /* 获取登录用户信息 */
    getUserInfo () {
      let loginInfo = sessionStorage.getItem('loginInfo')
      loginInfo = eval('(' + loginInfo + ')')
      return loginInfo
    }
  }
}
</script>
